import React from 'react';
import './Detail.scss';

export type DetailProps = {
    ariaLabelledBy?: string;
};

export const ICON_SIZE = 'small';
export const ICON_BLOCK = true;

export const DetailList: React.FC = ({ children }) => {
    return <div className="detail-list">{children}</div>;
};

export const Detail: React.FC<DetailProps> = ({ children, ariaLabelledBy }) => {
    return (
        <section aria-labelledby={ariaLabelledBy} className="detail">
            {children}
        </section>
    );
};

export const DetailIcon: React.FC = ({ children }) => {
    return <div className="detail__icon">{children}</div>;
};

export const DetailContent: React.FC = ({ children }) => {
    return <div className="detail__content">{children}</div>;
};

export const DetailHeading: React.FC = ({ children }) => {
    return <div className="detail__heading">{children}</div>;
};
